{
  "version": 1,
  "asset_id": "8796203a-07e1-48f9-beea-3fa7769e3380",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/8796203a-07e1-48f9-beea-3fa7769e3380/engine-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/8796203a-07e1-48f9-beea-3fa7769e3380/engine-thumb.webp",
  "original_filename": "engine-thumb.webp",
  "size": 9112,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:11Z"
}
